<div class="app-nav app-nav-mobile d-block d-sm-none">
  <i class="link font-22px" nz-icon nzType="images:nav" (click)="openMobileMenuDrawer()"></i>
  <nz-drawer [nzWidth]="'100%'" nzPlacement="right" [nzVisible]="mobileMenuDrawerVisible" (nzOnClose)="closeMobileMenuDrawer()">
    <ng-container *nzDrawerContent>
      <div class="app-nav-mobile-header">
        <app-logo (logoClicked)="logoClicked()"></app-logo>
        <i class="link font-18px" nz-icon nzType="images:close" (click)="closeMobileMenuDrawer()"></i>
      </div>
      <ul nz-menu [nzSelectable]="false" [nzMode]="'inline'">
        <li nz-menu-item [nzSelected]="accountsMenuSelected" (click)="navigateToAccounts()">
          {{ 'menu.main.accounts' | translate: locale.language | uppercase }}
        </li>
        @if (cardMenuVisible$ | async) {
        <li nz-menu-item [nzSelected]="cardsMenuSelected" [nzDisabled]="(cardMenuEnabled$ | async) === false" (click)="navigateToCards()">
          {{ 'menu.main.cards' | translate: locale.language | uppercase }}
        </li>
        }
        <li nz-submenu [nzTitle]="paymentsMenuTitleTpl" [class.app-nav-has-alert]="pendingOperationsCount$ | async">
          <ul>
            <app-payment-menu-items (itemClicked)="closeMobileMenuDrawer()"></app-payment-menu-items>
          </ul>
        </li>
        @if (loansMenuVisible$ | async) {
        <li nz-menu-item (click)="navigateToLoans()">{{ 'menu.main.loans.title' | translate: locale.language | uppercase }}</li>
        } @if (ebanksisLoansMenuVisible$ | async) {
        <li nz-menu-item (click)="navigateToLoansPreview()" [nzSelected]="loansMenuSelected">
          {{ 'menu.main.loansReview.title' | translate: locale.language | uppercase }}
        </li>
        }
        <li nz-submenu [nzTitle]="profileMenuTitleTpl">
          <ul>
            <app-user-menu-items (itemClicked)="closeMobileMenuDrawer()" [mobile]="true"></app-user-menu-items>
          </ul>
        </li>
        <li nz-menu-item class="app-nav-messages" (click)="navigateToMessages()">
          {{ 'menu.main.messages' | translate: locale.language | uppercase }} @if (messageCount$ | async; as messageCount) {
          <nz-badge class="app-nav-messages-badge" nzStandalone [nzCount]="messageCount.unread"></nz-badge>
          }
        </li>
      </ul>
    </ng-container>
  </nz-drawer>
</div>

<div class="app-nav d-none d-sm-block header-below">
  <ul nz-menu [nzSelectable]="false" nzMode="horizontal">
    <li nz-menu-item [nzSelected]="accountsMenuSelected" (click)="navigateToAccounts()">{{ 'menu.main.accounts' | translate: locale.language | uppercase }}</li>
    @if (cardMenuVisible$ | async) {
    <li nz-menu-item [nzSelected]="cardsMenuSelected" [nzDisabled]="(cardMenuEnabled$ | async) === false" (click)="navigateToCards()" data-cy="cards-menu">
      {{ 'menu.main.cards' | translate: locale.language | uppercase }}
    </li>
    }
    <li nz-menu-item nz-dropdown nzTrigger="click" nzPlacement="bottomRight" [nzDropdownMenu]="menuPayments" data-cy="payments-menu">
      <ng-container *ngTemplateOutlet="paymentsMenuTitleTpl"></ng-container>
    </li>
    @if (ebanksisLoansMenuVisible$ | async) {
    <li nz-menu-item (click)="navigateToLoansPreview()" [nzSelected]="loansMenuSelected">
      {{ 'menu.main.loansReview.title' | translate: locale.language | uppercase }}
    </li>
    } @if (loansMenuVisible$ | async) {
    <li nz-menu-item (click)="navigateToLoans()">{{ 'menu.main.loans.title' | translate: locale.language | uppercase }}</li>
    }
  </ul>
</div>

<nz-dropdown-menu #menuPayments="nzDropdownMenu">
  <app-payment-menu-items (itemClicked)="closeMobileMenuDrawer()"></app-payment-menu-items>
</nz-dropdown-menu>

<ng-template #paymentsMenuTitleTpl>
  @if (pendingOperationsCount$ | async) {
  <app-image class="app-nav-alert" name="alert-primary" [inlineSvg]="false"></app-image>
  }
  <span>{{ 'menu.main.payments.title' | translate: locale.language | uppercase }}</span><i nz-icon nzType="images:drop"></i>
</ng-template>

<ng-template #profileMenuTitleTpl>
  <span>{{ 'menu.main.profile' | translate: locale.language | uppercase }}</span><i nz-icon nzType="images:drop"></i>
</ng-template>
